// Sidebar.jsx — collapsible paper-wash nav rail.
// Collapsed: 48px icon rail. Expanded: 200px rail with labels.
// Toggle remembered across reloads via localStorage.
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NAV_ICONS = {
  toggle: "M3 5h18M3 12h18M3 19h18",
  home:   "M3 11l9-7 9 7v10H3z M9 21v-6h6v6",
  study:  "M4 4h16v16H4z M4 10h16 M10 4v16",
  graph:  "M6 6a2 2 0 114 0 2 2 0 01-4 0zM14 6a2 2 0 114 0 2 2 0 01-4 0zM10 18a2 2 0 114 0 2 2 0 01-4 0zM8 7l3 10M16 7l-3 10",
  plan:   "M5 4h14v16H5z M5 9h14 M9 4v16 M8 13h3 M8 16h3",
  reel:   "M4 5h16v14H4z M4 9h16 M4 15h16 M7 5v14 M17 5v14",
};

const NAV_PATH = {
  home: '/',
  study: '/study',
  plan: '/plan',
  graph: '/graph',
  reel: '/reel',
};

export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [expanded, setExpanded] = React.useState(
    () => localStorage.getItem("didactic.railExpanded") === "1"
  );
  const toggle = () => {
    setExpanded(v => {
      localStorage.setItem("didactic.railExpanded", v ? "0" : "1");
      return !v;
    });
  };

  const items = [
    { id: "home",  label: "Home" },
    { id: "study", label: "Study" },
    { id: "plan",  label: "Plan" },
    { id: "graph", label: "Graph" },
    { id: "reel",  label: "Struggle reel" },
  ];

  // Active item is derived from the URL path.
  const activeId = React.useMemo(() => {
    const p = location.pathname;
    if (p === '/' || p === '') return 'home';
    if (p.startsWith('/study')) return 'study';
    if (p.startsWith('/plan')) return 'plan';
    if (p.startsWith('/graph')) return 'graph';
    if (p.startsWith('/reel')) return 'reel';
    return null;
  }, [location.pathname]);

  return (
    <aside className={"didactic-rail" + (expanded ? " is-expanded" : "")}>
      <button
        className="rail-toggle"
        aria-label={expanded ? "collapse sidebar" : "expand sidebar"}
        onClick={toggle}
      >
        <svg viewBox="0 0 24 24" width="18" height="18"><path d={NAV_ICONS.toggle}/></svg>
      </button>
      <div className="rail-items">
        {items.map(it => (
          <button
            key={it.id}
            className={"rail-btn" + (activeId === it.id ? " active" : "")}
            onClick={() => navigate(NAV_PATH[it.id])}
            title={it.label}
          >
            <svg viewBox="0 0 24 24" width="18" height="18"><path d={NAV_ICONS[it.id]}/></svg>
            <span className="rail-btn-label">{it.label}</span>
          </button>
        ))}
      </div>
    </aside>
  );
}
